
import { defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n/index";
import KTMenu from "@/layout/aside/Menu.vue";
import { asideTheme } from "@/core/helpers/config";

export default defineComponent({
  name: "KTAside",
  inheritAttrs: false,
  components: {
    KTMenu,
  },
  props: {
    lightLogo: String,
    darkLogo: String,
    company: {
      type: Object,
      required: false,
      default: {}
    }
  },
  setup() {
    const { t } = useI18n();
    const terms = ref(process.env.VUE_APP_TERMS)
    const repo = ref(process.env.VUE_APP_REPO)

    return {
      repo,
      asideTheme,
      terms,
      t,
    };
  },
});
